import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = [ "admin--infection-reports--form-nested-row" ]
  destroyAllRows() {
    this.adminInfectionReportsFormNestedRowOutlets.forEach(controller => controller.destroyRow())
  }
}
